<div class="header-card d-flex bottom-xs">
  <h2 class="color-gray header-card_title u-medium f-20" >
    {{titleSite}}

    <div class="tooltip right">
      <img src="./assets/icons/icon-interrogative.svg" alt="Icono de exclamación"
      aria-label="Consulta aquí el estado de las afiliaciones de Trabajadores que hayas realizado"
        id="IMG_Exclamation consulta afiliaciones">

      <span class="tiptext">
        Consulta aquí el estado de las afiliaciones de Trabajadores que hayas realizado
      </span>
    </div>
  </h2>
</div>

<table aria-label="Tabla de histórico de afiliaciones" class="rwd-table" width="100%" height="100%" cellpadding="0" cellspacing="0" id="tableAffiliation">
	<thead class="thead">
		<th  scope = "col" class="text-gray-category color-gray">
			Código de proceso
		</th>

		<th  scope = "col" class="text-gray-category color-gray">
			Fecha de proceso
		</th>

		<th  scope = "col" class="text-gray-category color-gray">
			Estado en proceso
    </th>

    <th  scope = "col" class="text-gray-category color-gray">
			Detalle
		</th>
  </thead>

  <div class="row mt-masive" *ngIf="loadingTop">
    <div class="col-md-12 text-center">
      <div class="spinner-two spinner-two-blue"></div>
    </div>
  </div>

  <tbody>

    <tr *ngIf="affiliateProcess.length <= 0 && !loadingTop">
      <td colspan="4" style="text-align: center;">
        <span class="text-gray-category color-red">No hay procesos de afiliación recientes</span>
      </td>
    </tr>

		<tr *ngFor="let process of affiliateProcess; let i = index;">
			<td data-th="Código de proceso">
				<div>
          {{process.processCode}}
        </div>
			</td>

			<td data-th="Fecha de proceso">
				<div>
          {{process.processDate | date:'dd/MM/yyyy'}}
        </div>
			</td>

      <td data-th="Estado en proceso"
          class="text-gray-category"
          [ngClass]="{
            'color-blue': process.processStatusCode=== '01',
            'color-red': process.processStatusCode === '03',
            'color-green': process.processStatusCode === '02'
          }"
      >
				<div>
          {{ process.processStatusCode | formatStatusProcess }}
        </div>
			</td>

			<td data-th="Detalle" *ngIf="process.processExcelMas != null"  class="text-gray-category color-gray">
        <button type="button" appDebounceClickGeneral tabindex="0"
        data-category = "Inicio"
        data-action = "Histórico de Afiliaciones"
        data-label = "Descarga"
        data-event = "ga_event_descarga"
        [ngClass]="{'btn-opacity': process.processStatusCode=== '01'}"
        [disabled]="process.processStatusCode=== '01'"
        (click)="downloadElement(process, i)"
        class="icon-download-hover detail btn-nav"
        type="button"
        title="Descargar archivo de afiliación con código de proceso {{process.processCode}} fecha de proceso {{process.processDate | date:'longDate'}} estado de proceso {{process.processStatusCode | formatStatusProcess}}" >
          <img *ngIf="!loadingDetail[i]" src="./assets/icons/Excel.svg"
            alt="Ir a Descargar archivo de afiliación con código de proceso {{process.processCode}} fecha de proceso {{process.processDate | date:'longDate'}} estado de proceso {{process.processStatusCode | formatStatusProcess}}" />
          <div *ngIf="loadingDetail[i]"  class="spinner-two spinner-two-blue"></div>
        </button>
      </td>

      <td data-th="Detalle" *ngIf="process.processExcelMas == null" class="text-gray-category color-gray">

        <button type="button" appDebounceClickGeneral tabindex="0"
        data-category = "Inicio"
        data-action = "Histórico de Afiliaciones"
        data-label = "Consultar"
        data-event = "ga_event_consultar"
        [ngClass]="{'btn-opacity': process.processStatusCode=== '01'}"
        [disabled]="process.processStatusCode=== '01'" *ngIf="!loadingDetail[i]" (click)="showElement(process, i)"  class="icon-download-hover btn-not-outline detail btn-nav" >
          <img  src="./assets/icons/icon-eye.svg"
            alt="Visualizar archivo de afiliación con código de proceso {{process.processCode}} fecha de proceso {{process.processDate | date:'longDate'}} estado de proceso {{process.processStatusCode | formatStatusProcess}}"/>
        </button>
        <div *ngIf="loadingDetail[i]"  class="spinner-two spinner-two-blue"></div>
			</td>
    </tr>

    <div class="h-35"></div>
  </tbody>
</table>

<div class="content-btn-detail">
  <button type="button" appDebounceClickGeneral tabindex="0"
  data-category = "Inicio"
  data-action = "Histórico de Afiliaciones"
  data-label = "Ver más"
  data-event = "ga_event_vermas"
  class="bnt-datail btn-nav"
  (click)="openLink()">
    <!--<em class="material-icons">navigate_next</em>-->
    <span class="text-btn-datail">Consultar Históricos</span>
  </button>
</div>

